import { Box, styled, Typography } from "@mui/material";
import { BaseMatchState } from "../types/match";
import OfflineGameStepper from "../components/offlineGameStepper";
import colors from "../theme/colors";
import fonts from "../theme/fonts";
import { mediaQueries } from "../theme/breakpoints";
import { useContext, useEffect } from "react";
import { OnlineMatchContext } from "../contexts/OnlineMatchContext";
import OnlineGameStepper from "../components/onlineGameStepper";

interface MatchProps {
  matchState: BaseMatchState;
  selectGameType: Function;
  selectMatchType: Function;
  selectBotDifficulty: Function;
  selectX01Game: Function;
  resetMatchState: Function;
  startMatch: Function;
  rematchHandler: Function;
  selectX01InOut: Function;
  numPlayers: number;
  setNumPlayers: Function;
  beta?: boolean;
}

export default function Homepage({
  matchState,
  selectGameType,
  selectMatchType,
  selectBotDifficulty,
  selectX01Game,
  startMatch,
  rematchHandler,
  selectX01InOut,
  numPlayers,
  setNumPlayers,
  beta = false,
}: MatchProps) {
  const { online, clearOnlineStates, id } = useContext(OnlineMatchContext);

  useEffect(() => {
    if (id) {
      clearOnlineStates();
    }
  // eslint-disable-next-line
  }, []);

  return (
    <Wrapper>
      <Title>Wednesday Night Flights</Title>
      <Box
        display="flex"
        justifyContent="center"
        width="100%"
        paddingBottom="10px"
      >
        {online && beta ? (
          <OnlineGameStepper
            matchState={matchState}
            resetMatchState={rematchHandler}
            selectGameType={selectGameType}
            selectMatchType={selectMatchType}
            selectX01Game={selectX01Game}
            startMatch={startMatch}
            selectX01InOut={selectX01InOut}
          />
        ) : (
          <OfflineGameStepper
            matchState={matchState}
            resetMatchState={rematchHandler}
            selectGameType={selectGameType}
            selectMatchType={selectMatchType}
            selectBotDifficulty={selectBotDifficulty}
            selectX01Game={selectX01Game}
            startMatch={startMatch}
            selectX01InOut={selectX01InOut}
            beta={beta}
            numPlayers={numPlayers}
            setNumPlayers={setNumPlayers}
          />
        )}
      </Box>
    </Wrapper>
  );
}

const Wrapper = styled(Box)({
  height: "100%",
  width: "100vw",
  "@media(min-width: 1200px)": {
    height: `${window.innerHeight * 0.8}px`,
  },
});

const Title = styled(Typography)({
  paddingTop: "2%",
  paddingBottom: "2%",
  fontFamily: fonts.family.chalk,
  color: colors.lightBeige,
  fontSize: fonts.size.extraLarge,
  [mediaQueries.mobile]: {
    fontSize: fonts.size.large,
  },
});
